import { render } from "./MovimentacaoProcessualDetalhesComponent.vue?vue&type=template&id=0c4e8ec6&scoped=true"
import script from "./MovimentacaoProcessualDetalhesComponent.vue?vue&type=script&lang=js"
export * from "./MovimentacaoProcessualDetalhesComponent.vue?vue&type=script&lang=js"

import "./MovimentacaoProcessualDetalhesComponent.vue?vue&type=style&index=0&id=0c4e8ec6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4e8ec6"]])

export default __exports__